// material-ui
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// project imports
import NavGroup from './Navigation/NavGroup';
import SimpleBar from 'components/third-party/SimpleBar';
import menuItem from 'menu-items';

// ==============================|| DRAWER CONTENT ||============================== //

export default function DrawerContent() {
  const navGroups = menuItem.items.map((item) => {
    switch (item.type) {
      case 'group':
        return <NavGroup key={item.id} item={item} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Fix - Navigation Group
          </Typography>
        );
    }
  });

  return (
    <>
      <SimpleBar sx={{ '& .simplebar-content': { display: 'flex', flexDirection: 'column' }, borderRadius: '0 50px 0 0' }}>
        <Box sx={{ pt: 2 }} >{navGroups}</Box>
      </SimpleBar>
    </>
  );
}
